<template>
    <div class="md:grid md:grid-cols-12 md:gap-6">
        <div class="sm:col-span-4">
            <div class="mt-1">
                <FormLabel :value="$t('messages.quantity')" for="quantity">(1-15)</FormLabel>
                <FormInput
                    required
                    id="quantity"
                    v-model.number="form.quantity"
                    name="quantity"
                    type="number"
                    step="1"
                    min="1"
                    max="15"
                    class="mt-1"
                />
                <FormError :value="errors['options.quantity']" class="mt-2" />
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'ItemCardPackOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
